module.exports = __webpack_public_path__ + "static/media/walga-twl-logo-west-blue.87db372b.png";